import type { ModalComponent } from '@skeletonlabs/skeleton'

import ApproveModal from '@components/ApproveModal.svelte'
import CancelModal from '@components/CancelModal.svelte'
import DeleteModal from '@components/DeleteModal.svelte'
import EvaluateModal from '@components/EvaluateModal.svelte'
import TransferOwnershipModal from '@components/TransferOwnershipModal.svelte'
import RunDatasetQAModal from '@routes/data-qa/components/RunDatasetQAModal.svelte'
import DatasetModal from '@routes/data-qa/datasets/DatasetModal.svelte'
import RunLLMUnlearningModal from '@routes/llm/components/RunLlmUnlearningModal.svelte'
import EvalRunModal from '@routes/llm/evals/EvalRunModal.svelte'
import LaunchEvalModal from '@routes/llm/evals/LaunchEvalModal.svelte'
import LlmModal from '@routes/llm/llms/LlmModal.svelte'
import LlmRunOptionsModal from '@routes/llm/llms/LlmRunOptionsModal.svelte'
import DownloadUnlearnedModelModal from '@routes/llm/runs/DownloadUnlearnedModelModal.svelte'
import StorageFormModal from '@routes/storage-configs/StorageFormModal.svelte'
import RunUnlearningModal from '@routes/unlearn-data/components/RunUnlearningModal.svelte'
import ModelModal from '@routes/unlearn-data/models/ModelModal.svelte'
import ChangeUserAssociationModal from '@routes/user-associations/ChangeUserAssociationModal.svelte'

export const modalRegistry: Record<string, ModalComponent> = {
  // Set a unique modal ID, then pass the component reference
  deleteModal: { ref: DeleteModal },
  cancelModal: { ref: CancelModal },
  approveModal: { ref: ApproveModal },
  // ⬆️ TODO: Make modal code less repetitive (DRY it up a bit)
  changeUserAssociationModal: { ref: ChangeUserAssociationModal },
  storageFormModal: { ref: StorageFormModal },
  datasetModal: { ref: DatasetModal },
  modelModal: { ref: ModelModal },
  transferOwnershipModal: { ref: TransferOwnershipModal },
  runDatasetQAModal: { ref: RunDatasetQAModal },
  runUnlearningModal: { ref: RunUnlearningModal },
  llmModal: { ref: LlmModal },
  runLLMUnlearningModal: { ref: RunLLMUnlearningModal },
  evaluateModal: { ref: EvaluateModal },
  evalRunModal: { ref: EvalRunModal },
  launchEvalModal: { ref: LaunchEvalModal },
  llmRunOptionsModal: { ref: LlmRunOptionsModal },
  downloadUnlearnedModelModal: { ref: DownloadUnlearnedModelModal },
}
